import { Box, EllipsisBoxWithTooltip, Icon, type TradeSettleStatusEnum } from '@talos/kyoko';
import { memo } from 'react';
import type { DefaultTheme } from 'styled-components';
import { getLPTradeStatusMapping } from '../utils/lpTradeStatusMapping';

interface LPTradeStatusRendererProps {
  theme: DefaultTheme;
  status: TradeSettleStatusEnum;
}

export const LPTradeStatusRenderer = memo(({ theme, status }: LPTradeStatusRendererProps) => {
  const statusMapping = getLPTradeStatusMapping(status, theme);

  // If no status mapping, just show the raw status with empty space for icon
  if (!statusMapping) {
    return null;
  }

  const prefix = statusMapping.icon ? (
    <Icon icon={statusMapping.icon} size={16} color={statusMapping.color} />
  ) : (
    <Box w="12px" flex="0 0 auto" />
  );

  return (
    <EllipsisBoxWithTooltip prefixNode={prefix} tooltipProps={{ placement: 'bottom-start' }}>
      {statusMapping.label}
    </EllipsisBoxWithTooltip>
  );
});

LPTradeStatusRenderer.displayName = 'LPTradeStatusRenderer';
